import React from 'react';
import { useMediaQuery } from 'react-responsive';
import SunbaeBriefingBranchPc from './designcomponents/sunbaebriefingbranchpc';
import SunbaeBriefingBranchMobile from './designcomponents/sunbaebriefingbranchmobile';
import { GIMPO_CONFIG } from '../lib/briefingBranchConfig';

export default function SunbaeBriefingGimpo() {
  const isMobile = useMediaQuery({ query: '(max-width: 1024px)' });
  return isMobile
    ? <SunbaeBriefingBranchMobile config={GIMPO_CONFIG} />
    : <SunbaeBriefingBranchPc config={GIMPO_CONFIG} />;
}
